import React from "react";
import "./VangalContactDetails.css";

// Your actual logos (replace with real image paths)
import manufactureLogo from "../../Assets/logo.svg";
import marketLogo from "../../Assets/gopika-logo.png";

// React Icons
import { IoCall } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const VangalContactDetails = () => {
  return (
    <section className="vf-contact-details-wrapper">
      <div className="vf-contact-details-container">

        <h2 className="vf-contact-details-title anim anim-bottom">Contact & Product Information</h2>

        {/* Two Section Cards */}
        <div className="vf-contact-details-grid">

          {/* Manufactured By */}
          <div className="vf-contact-box anim anim-top">
            <img src={manufactureLogo} alt="Manufactured Logo" className="vf-contact-real-logo" />
            <h3 className="vf-contact-heading">Manufactured By</h3>
            <p>VANGAL DAIRIES</p>
            <p>54, Periyagoundampatti, Thalambadi Village,</p>
            <p>Namakkal, Tamil Nadu - 637019.</p>
            <p><strong>Lic. No:</strong> 12418014000539</p>
          </div>

          {/* Marketed By */}
          <div className="vf-contact-box anim anim-top">
            <img src={marketLogo} alt="Marketed Logo" className="vf-contact-real-logo" />
            <h3 className="vf-contact-heading">Marketed By</h3>
            <p>GOPIKA AGRO PRODUCT P LTD.</p>
            <p>54, Periyagoundampatti, Thalambadi Village,</p>
            <p>Namakkal, Tamil Nadu - 637019.</p>
            <p><strong>Lic. No:</strong> 12420014000591</p>
          </div>

        </div>

        {/* React Icons Contact Cards */}
        <div className="vf-contact-small-cards">

          <div className="vf-contact-small-card">
            <IoCall className="vf-contact-icon" />
            <p><strong>Customer Care</strong></p>
            <p>+91 7305044522</p>
          </div>

          <div className="vf-contact-small-card">
            <IoCall className="vf-contact-icon" />
            <p><strong>Phone</strong></p>
            <p>+91 04286-234369 / 259</p>
          </div>

<div className="vf-contact-small-card">
  <FaWhatsapp className="vf-contact-icon" />
  <p><strong>WhatsApp:</strong></p>
  <p>7305044522</p>
</div>
          <div className="vf-contact-small-card">
            <MdEmail className="vf-contact-icon" />
            <p><strong>Email:</strong></p>
             <p>admin@vangalgo.com.in</p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default VangalContactDetails;
